// @mui
import AppDialog from './AppDialog';
import ImportantNotice from './ImportantNotice';
// utils

// ----------------------------------------------------------------------

export default function DeactivateModal(props) {
    return (
        <>
            <AppDialog
                open={props.open}
                close={() => props.close()}
                title={`${props?.title ? props?.title : 'Deactivate'} ${props?.module || ''}`}
                positiveTitle={props?.title}
                positivePress={() => props.submit()}
                positiveButtonStyle={{ backgroundColor: '#454545', color: 'white', border: '1px solid #454545', height: 32, padding: 5 }}
                negativePress={() => props.close()}
                negativeButtonStyle={{ height: 32, padding: 5, paddingInline: 10, border: '1px solid #DDDDDD', backgroundColor: 'white', color: '#000000' }}
                negativeTitle={'Cancel'}
                width={'50%'}
            >
                <div className="pb-2">
                    Are you sure you want to {props?.title?.toLowerCase()} this {props?.module || ''}? {props?.title === "Deactivate" && "You can reactivate it later if needed."}
                    {
                        props?.message && props.message
                    }
                </div>
            </AppDialog>
        </>


    );
}
